import styled, { css } from "styled-components";
import { pageGutterSpace } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import ButtonAtm, { buttonAtmSizes, buttonAtmIconSizeSpace } from "../../atoms/ButtonAtm";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import WrapOrg from "../../organisms/WrapOrg";
export var background = "backgroundLight";
export var buttonSizeOnSmallOnly = "default";
export var buttonSizeOnMediumUp = "small";
export var Container = styled.div.withConfig({
  componentId: "sc-1n01ml8-0"
})(function (_ref) {
  var $hasBundle = _ref.$hasBundle,
    theme = _ref.theme;
  return css(["display:flex;align-items:center;padding:", " ", ";background:", ";", "{padding-inline:", ";}", ""], space(2), space(pageGutterSpace), getColor(theme, background), breakpoint("medium"), space(3), $hasBundle ? css(["box-shadow:", ";border-radius:", ";border:", " solid ", ";", "{padding:", " ", " ", " ", ";}"], getBoxShadow(theme, "tiny"), unit(8), unit(2), getColor(theme, "background"), breakpoint("small", "medium"), space(3), space(3), unit(18), space(3)) : null);
});
export var Main = styled.div.withConfig({
  componentId: "sc-1n01ml8-1"
})(function (_ref2) {
  var $hasBundle = _ref2.$hasBundle;
  return css(["display:flex;flex:1;flex-direction:column;padding-right:", ";", "{flex-direction:row;align-items:center;justify-content:space-between;}"], $hasBundle ? space(2) : space(3), breakpoint("medium"));
});
export var DomainAndLabelWrap = styled(WrapOrg).withConfig({
  componentId: "sc-1n01ml8-2"
})(function (_ref3) {
  var $hasImagesAndLabelBottomOnMobile = _ref3.$hasImagesAndLabelBottomOnMobile;
  return css(["align-items:center;", "{> *:last-child{order:-1;width:100%;padding-bottom:", ";}}", ""], breakpoint("small", "medium"), space(0.5), $hasImagesAndLabelBottomOnMobile ? css(["", "{flex-direction:column-reverse;align-items:flex-start;}"], breakpoint("small", "medium")) : null);
});
export var DomainContainer = styled.div.withConfig({
  componentId: "sc-1n01ml8-3"
})(["display:flex;flex-direction:column;> *{margin-bottom:", ";&:last-child{margin-bottom:0;}}"], space(0.5));
export var Domain = styled(TextAtm).withConfig({
  componentId: "sc-1n01ml8-4"
})(["display:flex;align-items:center;>{:first-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}:last-child{flex-shrink:0;}}"]);
export var PriceWrapper = styled.div.withConfig({
  componentId: "sc-1n01ml8-5"
})(["display:flex;align-items:center;text-align:right;", "{margin-top:", ";text-align:left;}", "{flex-direction:column;align-items:flex-end;}", "{margin-left:", ";}> *{margin-right:", ";&:last-child{margin-right:0;}", "{margin-right:0;}}"], breakpoint("small", "medium"), space(2), breakpoint("medium", "large"), breakpoint("medium"), space(2), space(1), breakpoint("medium", "large"));
export var Aside = styled.div.withConfig({
  componentId: "sc-1n01ml8-6"
})(function (_ref4) {
  var $hasError = _ref4.$hasError;
  return css(["display:flex;flex-shrink:0;justify-content:center;min-width:", ";", "{min-width:", ";max-width:100%;}"], space(buttonAtmIconSizeSpace + 2 * buttonAtmSizes[buttonSizeOnSmallOnly].paddingSpace["default"]), breakpoint("medium"), space($hasError ? buttonAtmIconSizeSpace + 2 * buttonAtmSizes[buttonSizeOnMediumUp].paddingSpace["default"] : 15));
});
export var StyledButton = styled(ButtonAtm).withConfig({
  componentId: "sc-1n01ml8-7"
})(["width:100%;"]);
export var PriceContainer = styled.div.withConfig({
  componentId: "sc-1n01ml8-8"
})(["display:flex;flex-direction:column;align-items:flex-end;", "{align-items:flex-start;}"], breakpoint("small", "medium"));
export var DomainNameContainer = styled.div.withConfig({
  componentId: "sc-1n01ml8-9"
})(["flex:1;"]);
export var PriceAndButtonWrapper = styled(FlexContainerOrg).withConfig({
  componentId: "sc-1n01ml8-10"
})(function (_ref5) {
  var $hasBundle = _ref5.$hasBundle;
  return css(["", "{min-width:", ";}"], breakpoint("medium"), $hasBundle ? space(29) : "auto");
});